define([], function setupInvisibleRecaptcha() {
  const Init = () => {
    const recaptchaEls = document.querySelectorAll(".recaptcha-render");

    // If there are no recaptcha elements on the page, return
    if (recaptchaEls.length === 0) {
      return;
    }

    const loadRecaptchaScript = () => {
      // `onload` query parameter is used to specify the callback function for recaptcha to call after loading the script.
      // `explicit` query parameter is used to indicate that the recaptcha widget will be rendered by our code. We want to
      // render it explicitly in order to get the "widget id", which will be useful when we have multiple recaptchas on
      // the same page
      // More info here: https://developers.google.com/recaptcha/docs/invisible#javascript_resource_apijs_parameters
      const scriptUrl =
        "https://www.google.com/recaptcha/api.js?onload=onloadInvisibleRecaptchaCallback&render=explicit";

      const script = document.createElement("script");
      script.setAttribute("src", scriptUrl);
      script.defer = true;
      document.body.appendChild(script);
    };

    const setupRecaptchaCallback = () => {
      window.onloadInvisibleRecaptchaCallback = () => {
        document
          .querySelectorAll(".recaptcha-render")
          .forEach((recaptchaEl) => {
            const textAreaId = recaptchaEl.dataset["recaptchaTextareaId"] || "";
            const textAreaEl = document.getElementById(textAreaId);

            if (!textAreaEl) {
              console.log(
                `Unable to find valid recaptcha text area element with id "${textAreaId}"`
              );
              return;
            }

            const callbackName = textAreaId + "__recaptcha-callback";
            window[callbackName] = (token) => {
              textAreaEl.value = token;
              setTimeout(() => (textAreaEl.value = ""), 110000);
              const button = textAreaEl
                .closest("form")
                ?.querySelector('[type="submit"]');
              button?.click();
            };

            const widgetId = grecaptcha.render(recaptchaEl, {
              sitekey: recaptchaEl.dataset["sitekey"],
              size: "invisible",
              callback: callbackName,
            });

            textAreaEl.dataset["recaptchaWidgetId"] = widgetId;
          });
      };
    };
    setupRecaptchaCallback();
    loadRecaptchaScript();
  };

  return {
    Init,
  };
});
